// extracted by mini-css-extract-plugin
export var employersImage = "index-module--employersImage--b183d";